import axios from "axios";
import { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import {
    Card,
    Input,
    Button,
    Form,
    InputNumber,
    message,
    Divider,
    Typography,
    Row,
    Col,
} from "antd";
import { SaveOutlined, EnvironmentOutlined } from "@ant-design/icons";

const { Title } = Typography;

export default function AddWorklocation() {
    const [submitting, setSubmitting] = useState(false);
    const [form] = Form.useForm();
    const { authData, backUrl } = useContext(AuthContext);

    // ✅ Submit work location
    const handleSubmit = async (values) => {
        setSubmitting(true);
        try {
            const payload = {
                name: values.name,
                full_name: values.full_name || null,
                latitude: values.latitude ?? null,
                longitude: values.longitude ?? null,
                radius: values.radius ?? null,
                bss_project: values.bss_project ?? null,
                short_latitude: values.short_latitude ?? null,
                short_longitude: values.short_longitude ?? null,
                short_radius: values.short_radius ?? null,
            };

            await axios.post(
                `${backUrl}/api/emp/worklocation/`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            message.success("Work location added successfully!");
            form.resetFields();
        } catch (err) {
            let errMsg = "Failed to add work location.";

            if (err.response) {
                errMsg =
                    err.response.data?.message ||
                    err.response.data?.detail ||
                    err.response.data?.name?.[0] ||
                    JSON.stringify(err.response.data);
            } else if (err.request) {
                errMsg = "No response from server. Please try again.";
            } else {
                errMsg = err.message;
            }

            message.error(errMsg);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div style={{ padding: "24px" }}>
            <Card
                style={{
                    maxWidth: 700,
                    margin: "0 auto",
                    borderRadius: 12,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
            >
                <Title level={4} style={{ textAlign: "center", color: "#0e497b" }}>
                    <EnvironmentOutlined style={{ marginRight: 8 }} />
                    Add Work Location
                </Title>

                <Divider />

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Name"
                                name="name"
                                rules={[
                                    { required: true, message: "Please enter a short, unique name." },
                                ]}
                            >
                                <Input placeholder="e.g., HEAD OFFICE" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Full Name"
                                name="full_name"
                            >
                                <Input placeholder="e.g., Head Office - Chennai" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider orientation="left" plain>
                        Geofence (Full)
                    </Divider>

                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item
                                label="Latitude"
                                name="latitude"
                            >
                                <InputNumber
                                    style={{ width: "100%" }}
                                    placeholder="e.g., 13.08268400"
                                    step={0.00000001}
                                    stringMode
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="Longitude"
                                name="longitude"
                            >
                                <InputNumber
                                    style={{ width: "100%" }}
                                    placeholder="e.g., 80.27070700"
                                    step={0.00000001}
                                    stringMode
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="Radius (meters)"
                                name="radius"
                            >
                                <InputNumber
                                    style={{ width: "100%" }}
                                    placeholder="e.g., 200"
                                    min={0}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider orientation="left" plain>
                        Geofence (Short)
                    </Divider>

                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item
                                label="Short Latitude"
                                name="short_latitude"
                            >
                                <InputNumber
                                    style={{ width: "100%" }}
                                    placeholder="e.g., 13.08268400"
                                    step={0.00000001}
                                    stringMode
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="Short Longitude"
                                name="short_longitude"
                            >
                                <InputNumber
                                    style={{ width: "100%" }}
                                    placeholder="e.g., 80.27070700"
                                    step={0.00000001}
                                    stringMode
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="Short Radius (meters)"
                                name="short_radius"
                            >
                                <InputNumber
                                    style={{ width: "100%" }}
                                    placeholder="e.g., 50"
                                    min={0}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* <Divider orientation="left" plain>
                        Integration
                    </Divider>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="BSS Project ID"
                                name="bss_project"
                            >
                                <InputNumber
                                    style={{ width: "100%" }}
                                    placeholder="e.g., 101"
                                />
                            </Form.Item>
                        </Col>
                    </Row> */}

                    <Form.Item style={{ marginTop: 12 }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={submitting}
                            icon={<SaveOutlined />}
                            block
                            style={{
                                backgroundColor: "#0e497b",
                                borderColor: "#0e497b",
                                height: 40,
                                borderRadius: 6,
                            }}
                        >
                            Submit Work Location
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
}